import { MetricOption, MetricType } from 'components/common/types/DrilldownReports.types';
import { NullableCodeName } from 'components/common/types/CodeName.types';
import { ProgrammaticAndDirectSalesBookingStatus } from '../types/Deal.types';

export enum AggregationFunction {
  AVG = 'avg',
  SUM = 'sum',
}

export enum ReportType {
  SAVED = 'SAVED',
  NOT_SAVED = 'NOT_SAVED',
}

export type AllocationModalReportType = 'frames' | 'allocation';

export interface SelectedLine {
  lineDefaultReportType: ReportType;
  lineId: string;
  lineName: string;
  lineStatus?: ProgrammaticAndDirectSalesBookingStatus;
}

export interface AllocationReportProps {
  dealLines: SelectedLine[];
  defaultSelectedLine: SelectedLine;
  changeReportSwitch?: JSX.Element;
  hasFramesReportEnabled?: boolean;
  isDirectSales: boolean;
  publicToken?: string;
  publicLocaleCode?: string;
  availableMetricOptions?: MetricOption[];
  availableGroupByOptions?: string[];
  isSelectAllDefault?: boolean;
  isSelectAllLocked?: boolean;
  isSelectHidden?: boolean;
}

export interface AllocationDay {
  date: string;
  hours?: number[];
  total: number;
}

export interface AllocationWeek {
  allocationWeek: number;
  allocationWeekStartDate?: string;
  days: AllocationDay[];
  total: number;
}

export interface Frame {
  allocations: AllocationWeek[];
  frameId: string;
  productFormat?: NullableCodeName;
  total?: number;
  town?: NullableCodeName;
  channel?: NullableCodeName;
  mediaType?: string;
  frameSizeFamily?: NullableCodeName;
  frameSize?: NullableCodeName;
  businessArea?: NullableCodeName;
  revenueStream?: NullableCodeName;
  country?: NullableCodeName;
  county?: NullableCodeName;
  district?: NullableCodeName;
  tvArea?: NullableCodeName;
  conurbation?: NullableCodeName;
}

interface MetaData {
  report: {
    id: string;
    version: number;
    creationDateTime: string;
  };
  deal: {
    id: string;
    startDateTime: string;
    endDateTime: string;
  };
}

export interface AllocationReportData {
  contractVersion: number;
  frames: Frame[];
  endDate: string;
  lineDuration: number;
  metaData?: MetaData;
  metricType: MetricType;
  rowGroupAggFunction: AggregationFunction;
  startDate: string;
  total: number;
  totalAllocations: AllocationWeek[];
}
